// @flow

import React from 'react';
import PropTypes from 'prop-types';
import CustomEvent from 'custom-event';
import Html from 'Html';

type EventPointProps = {
  entityLabel: PropTypes.string.isRequired,
  fieldDate: PropTypes.string.isRequired,
  fieldImage: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  map: PropTypes.shape.isRequired,
};

/* eslint-disable react/no-danger */
const EventPoint = ({
  entityLabel,
  fieldDate,
  fieldImage,
  body,
  map,
}: EventPointProps): React.Element<any> =>
  (<div className="map__event theme--blue-black">
    <button
      className="map__target btn btn--circle btn--circle--small"
      onClick={event => {
        event.preventDefault();
        global.dispatchEvent(new CustomEvent('mapModalsClosed'));
        event.target.parentNode.parentNode.classList.add('is-active');
        map.setOptions({ scrollwheel: false });
      }}
    >
      <span className="visually-hidden">
        {entityLabel}
      </span>
    </button>
    <div className="map__more-info">
      <Html className="map__marker map__marker--event-thumbnail center center--both">
        {fieldImage}
      </Html>
      <div className="map__tooltip tooltip tooltip--event center center--vertically">
        <div className="tooltip__scrollable">
          <div className="tooltip__content">
            <h4 className="tooltip__title h3 h3--medium">
              {entityLabel}
            </h4>
            <h5
              className="tooltip__description h3 h3--medium"
              dangerouslySetInnerHTML={{ __html: fieldDate }}
            />
            <Html className="wysiwyg wysiwyg--small">
              {body}
            </Html>
          </div>
        </div>
      </div>
    </div>
  </div>);
/* eslint-enable react/no-danger */

export default EventPoint;



// WEBPACK FOOTER //
// ./screens/App/components/MapEventPoint/index.js